import { AnimatedStModalBackdrop } from './ModalBackdrop.styled'

import type { MouseEventHandler, ReactNode } from 'react'

type ModalBackdropProps = {
  children: ReactNode
  onClick?: MouseEventHandler<HTMLDivElement>
  onMouseDown?: MouseEventHandler<HTMLDivElement>
  backdropColor?: string
}

const ModalBackdrop = ({ children, onClick, onMouseDown, backdropColor }: ModalBackdropProps) => {
  return (
    <AnimatedStModalBackdrop
      onClick={onClick}
      onMouseDown={onMouseDown}
      style={{ backgroundColor: backdropColor }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </AnimatedStModalBackdrop>
  )
}

export { ModalBackdrop }
